<template>
    <v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Awards & Badges"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="mt-6">
            <!-- <div class="d-flex align-center">
                <v-btn small depressed :class="(lang=='eng') ? 'primary white--text' : 'white grey--text text--darken-2'" @click="lang='eng'">ENGLISH</v-btn>
                <v-btn small depressed :class="(lang=='esp') ? 'primary white--text' : 'white grey--text text--darken-2'" @click="lang='esp'">ESPAÑOL</v-btn>
            </div> -->

            <div class="mt-2" v-if="lang=='eng'">
                The following are the most prestigious badge and awards in our 3 Step Program Online World Program. If you get one, it means you have earned it, and it will remain in your profile. It will reflect your effort and dedication and will forever be part of your life molecule. Most importantly, you will WANT to win as many badges and awards as possible because they will give you access to our 3 Steps Challenges. In our challenges, you will be able to gain incredible prices and experiences. Imagine yourself in a one to one coaching session with a top international CEO, or winning a 3 Steps Life Ryder (you don't know what it is? Believe me, you will want one) or a scholarship to one of our camps at RICE University. <br> <b></b>
                So, what are you waiting for? Go for it! 
            </div>
        </div>

        <div class="headline font-weight-medium primary--text mt-10">AWARDS</div>
        
        <!-- Top Prospect -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/topProspect.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>Top Prospect</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">This is our most prestigious award. It means you have surprised us at all levels. If you have this award, it means that part of the 3 Steps team will not hesitate to recommend you for a new job, internship, volunteering, and college. You surpassed our expectations. You are a champion, and you have shown it throughout the whole program. Congratulations because this award is only given to very few participants. You Rock !!!</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- Top Prospect -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/badgeEnergy.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>Energy Award</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You will win this award if you are capable of earning your five badges in less than three months. Woah! That will mean that with that energy and drive, no one stopping you!</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- Best Life Map -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/bestLifeMap.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>Best Life Map</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">The world is full of different GPS's, Google maps, Apple maps, but yours is unique and spectacular. Congratulations because a good map significantly increases your chances of reaching the goal. Always remember to "update" your map because, throughout your life, you will change course many times. Your map will serve as an inspiration and example for many who will come behind you. </div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- LinkedIn Future Master -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/linkedin.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>LinkedIn Future Master</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You will earn this award if you are capable of building an impressive reputation planner profile. It will mean that in your rookie year, you already mastered the tool. You have discovered the enormous potential of exploiting this way of connecting with others and presenting who you are. There are many adult professionals out there who will never dominate Linkedin as you do. Congratulations.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- 3STEPS Skills Pathr -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/3StepsSkillsPath.png')" width="90px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>3 STEPS Skills Path</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You made it. If you receive this award, it is because you completed our Skills Path successfully, and now you have tons of valuable information inside of you. Now it is time to put into practice what you have learned.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- Creativity Challenge Champion -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/champCreativity.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.champCreativity">fa-check</v-icon>
                        <span>Creativity Challenge Champion</span> 
                    </div> 
                    <div class="body-2" v-if="lang=='eng'">This award is given to the winners of the Creativity Challenge. Creativity is one of your strengths. If you earn this award, you will have the recommendation of a senior manager of a renowned company in your profile. Congratulations, now go and change the world.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Communication Challenge Champion -->
        <!-- <v-row class="mt-10">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/champCommunication.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.champCommunication">fa-check</v-icon>
                        <span>Communication Challenge Champion</span> 
                    </div> 
                    <div class="body-2" v-if="lang=='eng'">This award goes to the winning team of the Communication Challenge. It means that you had the best communication and marketing project. You got a standing ovation by a senior marketing team of a multinational, and this will also be in your profile with a written recommendation. Congratulations, what will be your next step? Maybe the marketing department of Disney, Amazon, Apple, Nike?</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Entrepreneurship Challenge Champion -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/champEntrepreneurship.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.champEntrepreneurship">fa-check</v-icon>
                        <span>Entrepreneurship Challenge Champion</span> 
                    </div> 
                    <div class="body-2" v-if="lang=='eng'">Your idea is a serious business. If you earned this award, it is because your team proved to have what it takes to surprise a Sharks panel. Now, do you have what it takes to make your project come true? This award certifies that you have the entrepreneurial spirit. You have also earned a written recommendation for your profile. Congratulations champ.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- ------------------------------------------------------------------------ -->
        <!-- BADGES -->
        <div class="mt-12">
            <div class="headline font-weight-medium primary--text">BADGES</div>
        </div>

        <!-- PROFILE -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/profile.png')" width="90px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>Profile</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You will earn your Profile badge once you completed all the elements within your profile. Earning this badge will be a good start for you. After winning this badge, it will be your responsibility to keep it updated, otherwise, you could lose it.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- Molecule -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/molecule.png')" width="90px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>Molecule</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You will earn this badge once you completed all the elements within your molecule. It will become a crucial step for you in the quest of knowing yourself. Everything starts in the mirror. Remember, you can edit, change, and modify your molecule as much as you want. It is a tool that will and should change over time, just like your life. </div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- Life Map -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/lifeMap.png')" width="90px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>Life Map</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You will earn this badge once you completed all the elements within your Life Map. But remember, completed doesn't mean done. You will need to keep this tool updated as you move along with the program and with your life. Like any good map, pay special attention to all the details.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- Top 3 -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/top3.png')" width="90px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>Top 3</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You will earn this badge once you completed all the elements within your Top 3. Now you will have an idea of what you want for college, career, and beyond. Now it is time to start working on a plan.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>

         <!-- Reputation Planner -->
        <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/reputationPlanner.png')" width="90px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <!-- <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.topProspect">fa-check</v-icon> -->
                        <span>Reputation Planner</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You will earn this badge once you completed all the elements within your Reputation Planner. It is crucial for your professional career and your chances to get into a good university or nail your dream job, to have a reliable and robust reputation online. Remember to keep this tool updated as you move along with your professional career.</div>
                </div>
            </v-col>
        </v-row>

        <!-- <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Communication Badge -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/badgeCommunication.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.badgeCommunication">fa-check</v-icon>
                        <span>Communication Badge</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">Words are your forte. You know how to communicate, express yourself, convince, tell a story. It is an excellent tool for everything you want to do in life. In other words, you have a “silver tongue”.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Creativity Badge -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/badgeCreativity.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.badgeCreativity">fa-check</v-icon>
                        <span>Creativity Badge</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You belong to the group of crazy scientists, Imagineers, the people who won't stop until they find a different way of doing things. You don't think inside the box, and your ability is the constant generation of ideas. Creativity is a muscle, cultivate it, and in the future, you will discover the enormous value that this rare skill has in the workplace.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Energy Badge -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/badgeEnergy.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.badgeEnergy">fa-check</v-icon>
                        <span>Energy Badge</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You are tireless. You push more than anyone else. Your attitude and your actions are the engines that move your team. Besides, your positive energy spreads all over the class. Your light shines brightly, and you will realize that you might be able to move mountains.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Collaboration Badge -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/badgeCollaboration.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.badgeCollaboration">fa-check</v-icon>
                        <span>Collaboration Badge</span> 
                    </div>
                    <div class="body-2">You are selfless, active, and a team player. You are always focused on the common goal, and you are crucial to making a group move forward. Everyone wants to have someone like you on their team. You value and acknowledge others, embrace diversity, and show respect for others’ feelings, concerns, and ideas. Never lose this talent.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Entrepreneurship Badge -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/bagdeEntrepreneurship.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.bagdeEntrepreneurship">fa-check</v-icon>
                        <span>Entrepreneurship Badge</span> 
                    </div>
                    <div class="body-2">You are a creative, brave, and self-motivated individual. You are not afraid of risk; in fact, you crave it. You are flexible and passionate about your ideas. You proved everyone to be a decisive and hard-working person. Keep cultivating this skill. If you don’t start your own business, any big corporation will be looking for you.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Leadership Badge -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/badgeLeadership.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.badgeLeadership">fa-check</v-icon>
                        <span>Leadership Badge</span> 
                    </div>
                    <div class="body-2">You can inspire and influence others to work as a team and towards a common goal. You have clear thoughts; hence you are the one with the vision who can lead a group through the right path. You are driven and determined. Your skill is unique and essential within a group of people. Be mindful and use it the right way.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Problem Solver -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/problemSolver.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.problemSolver">fa-check</v-icon>
                        <span>Problem Solver</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">Your superpower is to have a critical thinking mind. When a problem arises, your team stares at you, looking for a solution. Your approach to problems is unique, and you are always able to find the "point of no resistance." Cultivate this skill, and you will be an essential element in any team.</div>
                    <div class="body-2" v-if="lang=='esp'">Tu habilidad es el critical thinking pero enfocado de manera positiva. Cuando surge un problema tu equipo te mira buscando que aportes una solución. Tú approach a los problemas es especial y eres capaz de encontrar siempre el “punto de no resistencia”. Cultiva esta habilidad y serás un elemento esencial dentro de cualquier equipo de trabajo.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Best Life Map -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/bestLifeMap.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.bestLifeMap">fa-check</v-icon>
                        <span>Best Life Map</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">The world is full of different GPS's, Google Maps, Apple Maps, but your map is unique and spectacular. Congratulations, because a good plan significantly increases your chances of reaching your goals. Always remember to "update" your map because, throughout your life, you will change course many times. Your map will serve as an inspiration and example for many who will come behind you.</div>
                    <div class="body-2" v-if="lang=='esp'">El mundo esta lleno de distintos GPS’s. Está google maps, apple maps pero tu mapa es único y espectacular. Felicidades porque un buen mapa te ayuda a incrementar considerablemente tus posibilidades de llegar al objetivo. Recuerda siempre “actualizar” tu mapa ya que a lo largo de tu vida cambiarás de rumbo. Tu mapa servirá de inspiración y ejemplo para muchos que vendrán detrás de ti.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Linkedin Master -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/linkedin.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.linkedin">fa-check</v-icon>
                        <span>Linkedin Master</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You are in your rookie year, and you already master the tool. You have discovered the enormous potential of exploiting this way of connecting with others and presenting who you are. There are many adult professionals out there who don’t dominate LinkedIn as you do. Congratulations.</div>
                    <div class="body-2" v-if="lang=='esp'">Estás en tu año de novato y ya dominas la herramienta. Has descubierto el enorme potencial de explotar esta forma de conectarte con los demás y de presentar quien eres. Hay muchos profesionales adultos allá afuera que no dominan Linkedin como tu. Felicidades.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- Circle of Ridicule Champion -->
        <!-- <v-row class="mt-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/circleRidicule.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.circleRidicule">fa-check</v-icon>
                        <span>Circle of Ridicule Champion</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">You have learned to laugh at yourself like no one else. It’s not easy to look at ourselves in the mirror, find our imperfections, and be able to laugh at them. Control this skill, learn how to use it properly at the right times, and you will become a magnet. People applaud and admire those who can laugh at themselves. In life, people need to learn to laugh more, dance more and enjoy more, but you’re already doing it. Congratulations.</div>
                    <div class="body-2" v-if="lang=='esp'">Has aprendido a reirte de ti mismo como nadie. Felicidades, no es fácil vernos al espejo, encontrar nuestras imperfecciones y después ser capaces de reírnos de nosotros mismos y de la vida. Controla esta habilidad, aprende a utilizarla en los momentos adecuados y te convertirás en un imán. La gente aplaude y admira a quienes son capaces de reírse de si mismo. En la vida, la gente tiene que aprender a reírse más, bailar más, disfrutar más. Ya tu lo estás haciendo. Felicidades.</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row> -->

        <!-- The Advertsity Master -->
        <!-- <v-row class="mt-6 mb-6">
            <v-col cols="12" sm="4" md="3">
                <div class="d-flex justify-center">
                    <div>
                        <v-img :src="require('@/assets/awards/adversityMaster.png')" width="120px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div>
                    <div class="headline d-flex align-center">
                        <v-icon size="18px" color="green" class="mr-2" v-if="user.awards && user.awards.adversityMaster">fa-check</v-icon>
                        <span>The Advertsity Master</span> 
                    </div>
                    <div class="body-2" v-if="lang=='eng'">Adversity is your last name. You welcome adversity head-on, without fear, and with open arms. You had learned to turn it around, to transform adversity into opportunity, and to take advantage of something when everyone else thought it was lost. It is a highly valued skill in the world, cultivate it, and you will become a necessary piece within any work team. On a personal level, it will help you see the best of life.</div>
                    <div class="body-2" v-if="lang=='esp'">La adversidad es tu apellido. Miras la adversidad de frente, sin miedo y con los brazos abiertos. Has aprendido a darle la vuelta, a transformar adversidad en oportunidad y en sacar provecho a algo cuando todos ya lo veían perdido. Es una habilidad muy valorada en el mundo, cultívala y te volverás pieza necesaria dentro de cualquier equipo de trabajo y a nivel personal, te ayudará a ver siempre lo mejor de la vida.</div>
                </div>
            </v-col>
        </v-row> -->
    </v-card>
</template>

<script>

export default {
    data: () => ({
        lang: 'eng'
    })    
}
</script>